import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@icon/spinner.svg'
import _imports_1 from '@icon/spinner-gradient-dark.svg'
import _imports_2 from '@icon/spinner-gradient.svg'


const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "custom-file-simplified__content" }
const _hoisted_3 = { class: "custom-file-simplified__size__wrapper" }
const _hoisted_4 = {
  key: 1,
  class: "custom-file-simplified__in"
}
const _hoisted_5 = {
  type: "button",
  class: "custom-file-simplified__content"
}
const _hoisted_6 = { class: "custom-file-simplified__size__wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilePic = _resolveComponent("FilePic")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_ProgressLoadingLine = _resolveComponent("ProgressLoadingLine")!
  const _component_icon = _resolveComponent("icon")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_FileDownloadPic = _resolveComponent("FileDownloadPic")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.file.id,
    class: _normalizeClass(["custom-file-simplified", [
      `custom-file-simplified_${_ctx.fileMarkup}`,
      { 'is-previewable': _ctx.isPreviewable, 'is-not-openable': _ctx.isNotOpenable }
    ]])
  }, [
    (!_ctx.file.deleted)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "custom-file-simplified__in",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.showImage()), ["prevent"]))
        }, [
          _createVNode(_component_FilePic, {
            class: "custom-file-simplified__pic",
            fileName: _ctx.file.name
          }, null, 8, ["fileName"]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_BaseSubHeading, {
              weight: "400",
              size: "medium",
              className: "custom-file-simplified__cut-name",
              color: "monochrome-07"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.file.name), 1)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_3, [
              (_ctx.progress === 0)
                ? (_openBlock(), _createBlock(_component_BaseSubHeading, {
                    key: 0,
                    weight: "500",
                    size: "extra-small",
                    className: "custom-file-simplified__size",
                    color: "monochrome-05",
                    darkColor: "monochrome-04"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.downloadStatus ? _ctx.$t(`fileDownloadStatus.${_ctx.downloadStatus}`) : _ctx.fileSize), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_ProgressLoadingLine, {
                    key: 1,
                    class: "custom-file-simplified__progress",
                    progress: _ctx.progress
                  }, null, 8, ["progress"]))
            ])
          ])), [
            [_directive_tooltip, {
          content: _ctx.file.name,
          theme: 'info-tooltip',
          placement: 'bottom',
          popperClass: 'custom-file__tooltip'
        }]
          ]),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["custom-file-simplified__download", {
          'is-downloading': _ctx.downloadStatus,
          'is-preparing': _ctx.downloadStatus === 'preparing'
        }]),
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onFileDownload && _ctx.onFileDownload(...args)), ["prevent","stop"]))
          }, [
            (_ctx.downloadStatus)
              ? (_openBlock(), _createBlock(_component_Spinner, {
                  key: 0,
                  loading: true,
                  className: "custom-file__download-spinner"
                }, {
                  default: _withCtx(() => [
                    (_ctx.downloadStatus === 'preparing')
                      ? (_openBlock(), _createBlock(_component_icon, {
                          key: 0,
                          data: _imports_0,
                          width: "var(--icon-24)",
                          height: "var(--icon-24)",
                          color: "var(--monochrome02to36)",
                          class: "spin-animation"
                        }))
                      : (_ctx.isDark)
                        ? (_openBlock(), _createBlock(_component_icon, {
                            key: 1,
                            data: _imports_1,
                            original: "",
                            width: "var(--icon-24)",
                            height: "var(--icon-24)",
                            class: "spin-animation"
                          }))
                        : (_openBlock(), _createBlock(_component_icon, {
                            key: 2,
                            data: _imports_2,
                            original: "",
                            width: "var(--icon-24)",
                            height: "var(--icon-24)",
                            class: "spin-animation"
                          }))
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_FileDownloadPic, { key: 1 }))
          ], 2)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_FilePic, {
            class: "custom-file-simplified__pic",
            isRemoved: _ctx.file.deleted,
            fileName: _ctx.file.name
          }, null, 8, ["isRemoved", "fileName"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_BaseSubHeading, {
              weight: "400",
              size: "medium",
              className: "custom-file-simplified__cut-name",
              color: "monochrome-07"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.file.name), 1)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_6, [
              (_ctx.progress === 0)
                ? (_openBlock(), _createBlock(_component_BaseSubHeading, {
                    key: 0,
                    weight: "500",
                    size: "extra-small",
                    className: "custom-file-simplified__size",
                    color: "monochrome-05",
                    darkColor: "monochrome-04"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Deleted by " + _toDisplayString(_ctx.file.deletedBy?.fullName), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
  ], 10, _hoisted_1))
}